<template>
    <div class="field singleline" :class="{ 'required': required }">
        <div class="heading">
            <label>{{ label }}</label>
        </div>
        <div class="input">
            <input ref="autocomplete" type="text" :value="value.string">
        </div>
        <p v-if="v && v.$error" class="error text--orange small semi">
            This field is required
        </p>
    </div>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            default: null,
        },
        v: {
            type: Object,
            default: null,
        }
    },

    data() {
        return {
            autocomplete: null,
        }
    },

    mounted() {
        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {
            types: ['address'],
            componentRestrictions: { country: ['au', 'nz'] }
        });
        this.autocomplete.setFields(['formatted_address', 'geometry']);
        this.autocomplete.addListener('place_changed', this.getAddressData);
    },

    methods: {
        getAddressData() {
            const { formatted_address, geometry: { location: { lat, lng }} } = this.autocomplete.getPlace();
            this.$emit('input', {
                string: formatted_address,
                lat: lat(),
                lng: lng(),
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .error {
        margin-top: 0.5em;
    }
    .autocomplete-field {
        width: 100%;
    }
</style>
